import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Section } from '@atlaskit/menu';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { TeamSkeleton } from './team-skeleton';

const loadingContainerStyles = xcss({
	backgroundColor: 'elevation.surface.overlay',
	borderRadius: 'border.radius',
	boxShadow: 'elevation.shadow.overlay',
	width: '320px',
	display: 'block',
	alignItems: 'center',
	justifyContent: 'center',
	paddingLeft: 'space.200',
	paddingRight: 'space.200',
});

const styles = cssMap({
	headerSkeleton: {
		paddingTop: token('space.250'),
		paddingBottom: token('space.100'),
	},
	badgeSkeleton: {
		borderRadius: token('border.radius.100'),
		height: '16px',
		width: '24px',
	},
	titleSkeleton: {
		borderRadius: token('border.radius.400'),
		height: '16px',
		width: '160px',
	},
});

const TeamSelectorSkeleton = () => {
	return (
		<Box testId="testId-team-selector-skeleton" xcss={loadingContainerStyles}>
			<Inline xcss={styles.headerSkeleton} spread="space-between" alignBlock="center">
				<Box xcss={styles.titleSkeleton} backgroundColor="color.background.neutral" />
				<Box xcss={styles.badgeSkeleton} backgroundColor="color.background.neutral" />
			</Inline>
			<Section isList>
				{[...Array(3)].map((_, index) => (
					<TeamSkeleton key={index} />
				))}
			</Section>
		</Box>
	);
};

export default TeamSelectorSkeleton;
